<form [formGroup]="realtorForm" (ngSubmit)="submitRealtorForm()" autocomplete="off">
  <div class="row gy-3">
    <div class="col-12">
      <input-field
        [label]="'Brokerage Name'"
        [type]="'text'"
        [placeholder]="'Enter Brokerage Name'"
        formControlName="brokerageName"
        [requiredLabel]="true"
        [required]="true"
        [errormessage]="'Brokerage Name is required'"
      >
      </input-field>
    </div>
    <div class="col-12">
      <h4 class="mb-2">
        <i class="bi bi-person text-primary me-2"></i>
        Agent Information
      </h4>
      <hr class="mt-0 border-dark-subtle" />
    </div>
    <div class="col-12">
      <input-field
        [label]="'Agent First Name'"
        [type]="'text'"
        [placeholder]="'Enter First Name'"
        formControlName="agentFirstName"
        [requiredLabel]="true"
        [required]="true"
        [errormessage]="'First Name is required'"
      >
      </input-field>
    </div>
    <div class="col-12">
      <input-field
        [label]="'Agent Last Name'"
        [type]="'text'"
        [placeholder]="'Enter Last Name'"
        formControlName="agentLastName"
        [requiredLabel]="true"
        [required]="true"
        [errormessage]="'Last Name is required'"
      >
      </input-field>
    </div>
    <div class="col-12">
      <input-field
        [label]="'Phone'"
        [type]="'number'"
        [placeholder]="'Enter Phone'"
        formControlName="phone"
        [requiredLabel]="true"
        [required]="true"
        [errormessage]="'Phone is required'"
      >
      </input-field>
    </div>
    <div class="col-12">
      <input-field
        [label]="'Email'"
        [type]="'email'"
        [placeholder]="'Enter Email'"
        formControlName="email"
        [requiredLabel]="true"
        [required]="true"
        [errormessage]="'Email is required'"
      >
      </input-field>
    </div>

    <div class="col-12">
      <h4 class="mb-2">
        <i class="bi bi-geo-alt text-primary me-2"></i>
        Location
      </h4>
      <hr class="mt-0 border-dark-subtle" />
    </div>
  </div>
  <ng-container formGroupName="address">
    <div class="row gy-3">
      <div class="col-12">
        <generic-dropdown
          [items]="countries()"
          [label]="'Country'"
          [allowSearch]="true"
          [clearable]="true"
          [placeholder]="'Select'"
          formControlName="countryId"
        >
        </generic-dropdown>
      </div>
      <div class="col-lg-6">
        <generic-dropdown
          [items]="provincesByCountryIdDisplayList()"
          [label]="'Province/State'"
          [allowSearch]="true"
          [clearable]="true"
          [placeholder]="'Select'"
          formControlName="provinceId"
        >
        </generic-dropdown>
      </div>
      <div class="col-lg-6">
        <generic-dropdown
          [items]="citiesByProvinceIdDisplayList()"
          [label]="'City'"
          [allowSearch]="true"
          [clearable]="true"
          [placeholder]="'Select'"
          formControlName="cityId"
          [required]="true"
          [errormessage]="'City is required'"
        >
        </generic-dropdown>
      </div>
    </div>
  </ng-container>

  @if (enableRecaptcha()) {
    <div class="row mt-3">
      <div class="col-12">
        <h4 class="mb-2">
          <i class="bi bi-shield-check text-primary me-2"></i>
          Verification
        </h4>
        <hr class="mt-0 border-dark-subtle" />
        <div id="recaptcha-container" class="d-flex justify-content-center"></div>
      </div>
    </div>
  }
</form>
